export { default } from './ContributorSendStarDialog';
